import * as React from "react";

import { useMergeRefs } from "@floating-ui/react";

import { usePopoverContext } from "./context";

interface ToggleChildrenProps {
  isOpened: boolean;
  onToggle: () => void;
  ref: React.Ref<any>;
}

interface PopoverToggleProps {
  children: (props: ToggleChildrenProps) => React.ReactNode;
}

export const PopoverToggle = React.forwardRef<HTMLElement, PopoverToggleProps>(
  ({ children }, propRef) => {
    const { context, refs } = usePopoverContext();
    const ref = useMergeRefs([refs.setReference, propRef]);

    return children({
      isOpened: context.open,
      onToggle: () => context.onOpenChange(!context.open),
      ref,
    });
  }
);
